export class MRMAwardCreateUpdateRequest {
    body: MRMAwardCreateUpdateBody = new MRMAwardCreateUpdateBody();
}
export class MRMAwardCreateUpdateBody {
    "ProcessName": string = 'DC Create Update MRM SR WF';
    'DC Method': string = 'SAVEASDRAFT';
    'DC Channel': string = 'Online';
    'DC Payment Method': string = 'Online';
    'SR Type': string = 'MRM Awards';
    'SR Sub Type': string = 'MRM Application';
    'Unit Price': string = '';
    'Member Name English': string = '';
    'Member Name Arabic': string = '';
    'Member Number': string = '';
    'Deligates Number': string = '';
    "Language": string = 'ENU';
    "SR Number": string = ""
}
